import * as RouteLink from "./constants/routeLink";
import Home from "./pages/Home/index";

import Bet from "./pages/Bet/index";
import History from "./pages/History/index";
import Member from "./pages/Member/index";
import Wallet from "./pages/Wallet/index";
import CreateToken from "./pages/CreateToken/index";
import Competition from "./pages/Competition/index";
import Profile from "./pages/Profile/index";
import Referral from "./pages/Referral/index";
import Airdrop from "./pages/Airdrop/index";


const routers = [
    {
      path: RouteLink.HOME,
      exact: false,
      name: "Home",
      key: "Home",
      main: ({ match, history, routers }) => (
        <Home match={match} history={history} routers={routers} />
      ),
      routers: [
      ]
    },
    {
      path: RouteLink.AIRDROP,
      exact: false,
      name: "Airdrop",
      key: "Airdrop",
      main: ({ match, history, routers }) => (
        <Airdrop match={match} history={history} routers={routers} />
      ),
      routers: [
      ]
    },
    {
      path: RouteLink.REFERRAL,
      exact: false,
      name: "Referral",
      key: "Referral",
      main: ({ match, history, routers }) => (
        <Referral match={match} history={history} routers={routers} />
      ),
      routers: [
      ]
    },
    {
      path: RouteLink.PROFILE,
      exact: false,
      name: "Profile",
      key: "Profile",
      main: ({ match, history, routers }) => (
        <Profile match={match} history={history} routers={routers} />
      ),
      routers: [
      ]
    },
    {
      path: RouteLink.COMPETITION,
      exact: false,
      name: "Competition",
      key: "Competition",
      main: ({ match, history, routers }) => (
        <Competition match={match} history={history} routers={routers} />
      ),
      routers: [
      ]
    },
    {
      path: RouteLink.CREATE_TOKEN,
      exact: false,
      name: "CreateToken",
      key: "CreateToken",
      main: ({ match, history, routers }) => (
        <CreateToken match={match} history={history} routers={routers} />
      ),
      routers: [
      ]
    },
    {
      path: RouteLink.BET,
      exact: false,
      name: "Bet",
      key: "Bet",
      main: ({ match, history, routers }) => (
        <Bet match={match} history={history} routers={routers} />
      ),
      routers: [
      ]
    },
    {
      path: RouteLink.HISTORY,
      exact: false,
      name: "History",
      key: "History",
      main: ({ match, history, routers }) => (
        <History match={match} history={history} routers={routers} />
      ),
      routers: [
      ]
    },
    {
      path: RouteLink.MEMBER,
      exact: false,
      name: "Member",
      key: "Member",
      main: ({ match, history, routers }) => (
        <Member match={match} history={history} routers={routers} />
      ),
      routers: [
      ]
    },
    {
      path: RouteLink.WALLET,
      exact: false,
      name: "Wallet",
      key: "Wallet",
      main: ({ match, history, routers }) => (
        <Wallet match={match} history={history} routers={routers} />
      ),
      routers: [
      ]
    },
]


export default routers;